/*
 * Copyright (c) 2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// Taken from https://www.nationalnanpa.com/number_resource_info/area_code_maps.html.
export const NORTH_AMERICA_REGION_CODES: Record<string, number[]> = {
  // Canada.
  CA: [
    204, 226, 236, 249, 250, 263, 289, 306, 343, 354, 365, 367, 368, 403, 416, 418, 431, 437, 438, 450, 468, 474, 506, 514, 519, 548, 579,
    581, 584, 587, 604, 613, 639, 647, 672, 683, 705, 709, 742, 753, 778, 780, 782, 807, 819, 825, 867, 873, 902, 905
  ],
  // Bahamas.
  BS: [242],
  // Barbados.
  BB: [246],
  // Anguilla.
  AI: [264],
  // Antigua/Barbuda.
  AG: [268],
  // British Virgin Islands.
  VG: [284],
  // US Virgin Islands.
  VI: [340],
  // Cayman Islands.
  KY: [345],
  // Bermuda.
  BM: [441],
  // Grenada.
  GD: [473],
  // Turks & Caicos Islands.
  TC: [649],
  // Montserrat.
  MS: [664],
  // Northern Marianna Islands (CNMI).
  MP: [670],
  // Guam.
  GU: [671],
  // American Samoa.
  AS: [684],
  // Sint Maarten.
  SX: [721],
  // St. Lucia.
  LC: [758],
  // Puerto Rico.
  PR: [787, 939],
  // Dominica.
  DM: [767],
  // St. Vincent & Grenadines.
  VC: [784],
  // Dominican Republic.
  DO: [809, 829, 849],
  // Trinidad & Tobago.
  TT: [868],
  // St. Kitts & Nevis.
  KN: [869],
  // Jamaica.
  JM: [658, 876]
}
